import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { colors } from "utils/styles";

import { Icon } from "components/Icons";
import Input from "components/Reusables/Input";
import ButtonGroup from "@components/Reusables/ButtonGroup";

export default function IconButton(props) {
	const {
		label,
		icon,
		onClick = () => {},
		button1Variant,
		additionalClasses,
		groupClasses,
		outlineColor,
		buttonWidth = { xs: "auto" },
		btn1,
		isDisabled = false,
	} = props;

	return (
		<ButtonGroup
			isDisabled={isDisabled}
			buttonWidth={buttonWidth}
			onClick={onClick}
			outlineColor={outlineColor}
			additionalClasses={`${additionalClasses} d-inline`}
			groupClasses={`${groupClasses} d-inline`}
			button1Variant={button1Variant}
			btn1={btn1}
			button1Children={
				<>
					<div className="row g-0 d-flex align-items-center assessment-item  px-3 radius-5px">
						{!!icon && (
							<Col xs={"auto"} className="d-flex flex-div  me-2 ">
								<Icon color={colors.darkBlue} icon={icon} />
							</Col>
						)}
						<Col xs={"auto"} className=" ">
							<span className="assessment-label">{label}</span>
						</Col>
					</div>
				</>
			}
		/>
	);
}
